const SectionForPartners = Class(
	/**
	 * @lends {SectionForPartners#}
	 */
	{
		menuItem: 'for-partners',

		draw: function() {
			this.node = mkE({
				tag: 'div',
				id: 'SectionForPartners',
				els: [
					{
						tag: 'div',
						id: 'hero',
						className: 'container',
						els: [
							{
								tag: 'h1',
								innerHTML: t('b2b.for-partners.hero.h1')
							},
							{
								tag: 'div',
								className: 'hero__btn',
								els: [
									{
										tag: 'a',
										className: 'button button-pink',
										onclick: function(e) {
											e.preventDefault();
											D.scrollIntoView(document.getElementById('form'), null, 200);
										},
										text: t('b2b.for-partners.hero.btn')
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'container mb-5 for_partners__how',
						els: [
							{
								tag: 'div',
								className: 'h-overline',
								text: t('b2b.for-partners.how.overline')
							},
							{
								tag: 'h2',
								className: 'mb-3',
								text: t('b2b.for-partners.how.title')
							},
							{
								tag: 'div',
								className: 'mb-3',
								els: [
									{
										tag: 'h4',
										className: 'mb-2',
										text: t('b2b.for-partners.how.title')
									},
									{
										tag: 'ul',
										className: 'default-list default-list-small',
										innerHTML: t('b2b.for-partners.how.list')
									}
								]
							},
							{
								tag: 'div',
								className: 'mb-3',
								els: [
									{
										tag: 'h2',
										className: 'mb-2',
										text: t('b2b.for-partners.what.title')
									},
									{
										tag: 'ul',
										className: 'default-list default-list-small',
										innerHTML: t('b2b.for-partners.what.list')
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'for_partners__contact mb-5',
						els: [
							{
								tag: 'div',
								className: 'container h-overline',
								text: t('b2b.for-partners.contact.overline')
							},
							{
								tag: 'h2',
								className: 'container mb-4',
								text: t('b2b.for-partners.contact.h2')
							},
							{
								tag: 'div',
								id: 'form',
								className: 'container mb-4',
								els: [
									{
										tag: 'div',
										className: 'contacts__block contacts__block--form',
										els: [
											new SectionForPartners.Form({
												type: 'b2b/for-partners',
												ref: this.url.get.v('ref') || null
											})
										]
									}
								]
							},
							{
								tag: 'div',
								className: 'container',
								els: [
									{
										tag: 'div',
										className: 'contacts__block',
										els: [
											{
												tag: 'div',
												className: 'overline',
												text: t('b2b.for-partners.links.overline1')
											},
											{
												tag: 'div',
												className: 'contact-items',
												els: [
													{
														tag: 'a',
														className: 'item item--email',
														href: 'mailto:' + D.Lang.get('b2b.for-partners.links.email'),
														text: D.Lang.get('b2b.for-partners.links.email')
													}
												]
											}
										]
									}
								]
							}
						]
					},
					new T.FAQ({
						title: D.Lang.get('b2b.for-partners.faq.title'),
						prefix: 'b2b.for-partners.faq',
						className: 'mb-5 container'
					})
				]
			}).append(this.layout.ct());

			this.ready();
		},

		onShow() {
			this.fadeOnShow();
		},

		onScroll() {
			this.fadeOnScroll();
		}

	},
	Section
);

/**
 * @class
 * @extends T.CorporateForm
 */
SectionForPartners.Form = Class(
	/**
	 * @lends {SectionForPartners.Form#}
	 */
	{
		METHOD: 'submitContactFormBusiness',
		draw() {
			let els = [
				{
					tag: 'div',
					className: 'bs-row',
					els: [
						{
							tag: 'div',
							className: 'col-12 col-md-6',
							els: [
								this.name({
									minLength: 2,
									required: true
								})
							]
						},
						{
							tag: 'div',
							className: 'col-12 col-md-6',
							els: [
								this.phone({
									required: true
								})
							]
						}
					]
				},
				{
					tag: 'div',
					className: 'bs-row',
					els: [
						{
							tag: 'div',
							className: 'col-12 col-md-7',
							els: [
								this.email({
									required: true
								})
							]
						},
						{
							tag: 'div',
							className: 'col-12 col-md-5',
							els: [
								this.country({
									required: true
								})
							]
						}
					]
				},
				{
					tag: 'div',
					className: 'bs-row',
					els: [
						{
							tag: 'div',
							className: 'col-12',
							els: [
								this.message({
									rows: 10
								})
							]
						}
					]
				},
				this.footer()
			];
			mkE.appendTypeElement(this.node, els);
		}
	},
	T.CorporateForm
);